export const AGGREGATION_TIME_FORMAT: string = 'YYYY-MM-DDTHH:mm:ss';

// Historical aggregation cache settings
export const AGGREGATION_THRESHOLD: Record<string, any> = {
    AMOUNT: 5,
    UNIT: 'minutes',
};
